// ~/plugins/global-components.ts
import { defineNuxtPlugin } from '#app'
import Frame from '@/components/helios/Frame.vue'

export default defineNuxtPlugin((nuxtApp) => {
  // The first arg is the name you’ll use in templates:
  nuxtApp.vueApp.component('Frame', Frame)
})